import React from 'react';
import AudioButton from './AudioButton';
import '../styles/LanguageLabels.css';
import '../styles/animations.css';
import categoriesData from '../data/categories.json';

const LanguageLabels = ({ item, displayMode = 'all' }) => {
  // Get translations for the current item from categories.json
  const getItemTranslations = () => {
    // Search through all categories and their elements
    for (const category of categoriesData.categories) {
      const element = category.elements.find(elem => elem.id === item);
      if (element) {
        return element.name || {};
      }
    }
    return {};
  };
  
  const itemTranslations = getItemTranslations();
  const englishLabel = itemTranslations.en || item;
  
  // Render labels based on display mode
  const renderLabels = () => {
    switch (displayMode) {
      case 'en':
        return (
          <div className="labels-container animate-scaleIn">
            <div className="label transition-all">
              <span className="language-tag">EN</span>
              <span className="language-label">{itemTranslations.en || item}</span>
              <AudioButton text={itemTranslations.en || item} language="en" className="hover-scale" />
            </div>
          </div>
        );
      case 'ar':
        return (
          <div className="labels-container animate-scaleIn">
            <div className="label rtl transition-all">
              <span className="language-tag">AR</span>
              <span className="language-label">{itemTranslations.ar || item}</span>
              <AudioButton text={itemTranslations.ar || item} language="ar" className="hover-scale" />
            </div>
          </div>
        );
      case 'de':
        return (
          <div className="labels-container animate-scaleIn">
            <div className="label transition-all">
              <span className="language-tag">DE</span>
              <span className="language-label">{itemTranslations.de || item}</span>
              <AudioButton text={itemTranslations.de || item} language="de" className="hover-scale" />
            </div>
          </div>
        );
      case 'all':
      default:
        return (
          <div className="labels-container animate-scaleIn">
            {displayMode === 'all' || displayMode === 'english' ? (
              <div className="label transition-all">
                <span className="language-tag">EN</span>
                <span className="language-label">{englishLabel}</span>
                <AudioButton text={englishLabel} language="en" className="hover-scale" />
              </div>
            ) : null}
            <div className="label rtl transition-all">
              <span className="language-tag">AR</span>
              <span className="language-label">{itemTranslations.ar || item}</span>
              <AudioButton text={itemTranslations.ar || item} language="ar" className="hover-scale" />
            </div>
            <div className="label transition-all">
              <span className="language-tag">DE</span>
              <span className="language-label">{itemTranslations.de || item}</span>
              <AudioButton text={itemTranslations.de || item} language="de" className="hover-scale" />
            </div>
          </div>
        );
    }
  };

  return (
    <div className="language-labels animate-fadeIn">
      {renderLabels()}
    </div>
  );
};

export default LanguageLabels;
